import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import "../../../constants/index.js";
import useThemePresetClasses from "../../../hooks/useThemePresetClasses.js";
import { cn } from "../../../utils/cn.js";
import { useState, useEffect } from "react";
import { useSwipeable } from "../../../external/react-swipeable/es/index.js";
import { Transition as Xe, TransitionChild as Le } from "../../../external/@headlessui/react/dist/components/transition/transition.js";
import { TRANSITION_IN_SLIDE_DOWN, TRANSITION_OUT_SLIDE_UP, TRANSITION_IN_SLIDE_UP, TRANSITION_OUT_SLIDE_DOWN, TRANSITION_IN_SLIDE_RIGHT, TRANSITION_OUT_SLIDE_LEFT, TRANSITION_IN_SLIDE_LEFT, TRANSITION_OUT_SLIDE_RIGHT } from "../../../constants/animations.js";
const TRANSITION_MAP = {
  top: {
    ...TRANSITION_IN_SLIDE_DOWN,
    ...TRANSITION_OUT_SLIDE_UP
  },
  bottom: {
    ...TRANSITION_IN_SLIDE_UP,
    ...TRANSITION_OUT_SLIDE_DOWN
  },
  left: {
    ...TRANSITION_IN_SLIDE_RIGHT,
    ...TRANSITION_OUT_SLIDE_LEFT
  },
  right: {
    ...TRANSITION_IN_SLIDE_LEFT,
    ...TRANSITION_OUT_SLIDE_RIGHT
  }
};
function Drawer({
  open,
  onClose,
  placement = "bottom",
  preload = false,
  onBackdropClick = onClose,
  classes,
  className,
  children,
  floatingHandle,
  safeZone,
  variant = "compact",
  hideHandler
}) {
  const { themeClasses } = useThemePresetClasses("Drawer", classes, className, {
    variant
  });
  const [isOnSwipe, setIsOnSwipe] = useState(false);
  const handlers = useSwipeable({
    onSwipedDown: onClose,
    trackTouch: true,
    trackMouse: true,
    onSwipeStart: (e) => {
      if (e.dir === "Down") {
        setIsOnSwipe(true);
      }
    },
    onSwiped: (e) => {
      setIsOnSwipe(false);
    }
  });
  useEffect(() => {
    if (open) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowY = "auto";
    }
  }, [open]);
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    Xe,
    {
      show: open,
      unmount: !preload,
      appear: true,
      children: /* @__PURE__ */ jsxs("div", { className: cn(themeClasses == null ? void 0 : themeClasses.root), children: [
        /* @__PURE__ */ jsx(
          Le,
          {
            unmount: !preload,
            appear: true,
            children: /* @__PURE__ */ jsx(
              "div",
              {
                onClick: (e) => {
                  e.stopPropagation();
                  onBackdropClick();
                },
                className: cn(themeClasses == null ? void 0 : themeClasses.backDrop),
                "aria-label": "Drawer backdrop"
              }
            )
          }
        ),
        /* @__PURE__ */ jsx(Le, { children: /* @__PURE__ */ jsx(
          "div",
          {
            className: cn("grow transition duration-300 data-[closed]:opacity-0", themeClasses == null ? void 0 : themeClasses.gap, {
              "max-h-full": variant === "compact",
              "max-h-0": variant === "full-screen"
            })
          }
        ) }),
        /* @__PURE__ */ jsx(Le, { ...TRANSITION_MAP[placement], children: /* @__PURE__ */ jsxs(
          "div",
          {
            className: cn("relative z-20 transition-all", themeClasses == null ? void 0 : themeClasses.container, {
              "mt-10": placement === "bottom",
              "mb-10": placement === "top",
              "mr-10": placement === "left",
              "ml-10": placement === "right",
              [(themeClasses == null ? void 0 : themeClasses.safeZone) ?? ""]: !!safeZone,
              "!m-0": variant === "full-screen",
              "translate-y-2": isOnSwipe
            }),
            children: [
              variant === "compact" && /* @__PURE__ */ jsx(
                "div",
                {
                  ...handlers,
                  className: cn("absolute -top-4 left-0 z-50 h-12 w-full")
                }
              ),
              !hideHandler && /* @__PURE__ */ jsx(
                "div",
                {
                  className: cn("flex-shrink-0 overflow-hidden transition-[max-height]", themeClasses == null ? void 0 : themeClasses.drawerTop, {
                    "absolute left-0 top-0 w-full": floatingHandle,
                    "max-h-0": variant === "full-screen",
                    "!max-h-[12px]": variant === "compact"
                  }),
                  children: /* @__PURE__ */ jsx(
                    "div",
                    {
                      className: cn("mt-2 h-1 w-9 rounded-lg bg-white/15 transition-[background-color]", {
                        "!bg-white": isOnSwipe
                      })
                    }
                  )
                }
              ),
              /* @__PURE__ */ jsx("div", { className: cn("overflow-y-auto", themeClasses == null ? void 0 : themeClasses.drawerBody), children })
            ]
          }
        ) })
      ] })
    }
  ) });
}
export {
  Drawer as default
};
